module.exports = __webpack_public_path__ + "img/1564668015.827e6dfa.jpg";